import {
    FETCH_FEATURE_FLAGS,
    FETCH_FEATURE_FLAGS_SUCCESS,
    FETCH_FEATURE_FLAGS_FAILED,
    UPDATE_FEATURE_FLAGS,
} from '../../store/types';


const initialState = {
    data: null,
    loading: false,
    error: null
};

export const featureFlagsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FEATURE_FLAGS:
            return {
                ...state,
                loading: true
            };
        case FETCH_FEATURE_FLAGS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case UPDATE_FEATURE_FLAGS:
            return state;
        case FETCH_FEATURE_FLAGS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default featureFlagsReducer;
